import React from 'react'

export default function NftCards() {
	const style = {
		backgroundColor: '#9A99FF',
	}
	return (
		<>
			<section
				className="nft-cards elementor-section elementor-top-section elementor-element elementor-element-d7597ef elementor-section-boxed elementor-section-height-default elementor-section-height-default"
				data-id="d7597ef"
				data-element_type="section"
				data-settings='{"background_background":"classic"}'
				style={style}>
				{/* center image */}
				<style
					dangerouslySetInnerHTML={{
						__html:
							'\n                                        /*! elementor - v3.5.6 - 28-02-2022 */\n\n                                        .elementor-widget-image {\n                                            text-align: center\n                                        }\n\n                                        .elementor-widget-image a {\n                                            display: inline-block\n                                        }\n\n                                        .elementor-widget-image a img[src$=".svg"] {\n                                            width: 48px\n                                        }\n\n                                        .elementor-widget-image img {\n                                            vertical-align: middle;\n                                            display: inline-block\n                                        }\n                                    ',
					}}
				/>
				<div className="nft-col elementor-container elementor-column-gap-default">
					<h2 className="h3 text-center pb-3">Metamates Collection</h2>
					<div className="nft-row">
						<div
							className="card elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-f10515a"
							data-id="f10515a"
							data-element_type="column">
							<div className="elementor-widget-wrap elementor-element-populated">
								<div
									className="elementor-element elementor-element-544481d elementor-widget elementor-widget-image"
									data-id="544481d"
									data-element_type="widget"
									data-widget_type="image.default">
									<div className="elementor-widget-container">
										<a href="https://www.linkedin.com/in/joeypescatore/">
											<img
												width={1080}
												height={1080}
												src="assets/collections/lusty-caller.png"
												className="elementor-animation-shrink attachment-large size-large jetpack-lazy-image"
											/>
										</a>
									</div>
								</div>
								<div
									className="elementor-element elementor-element-c3e852c elementor-widget elementor-widget-heading"
									data-id="c3e852c"
									data-element_type="widget"
									data-widget_type="heading.default">
									<div className="elementor-widget-container">
										<h2 className="nft-card-heading elementor-heading-title elementor-size-default">
											<a href="https://www.linkedin.com/in/joeypescatore/">
												Lusty Caller
											</a>
										</h2>
									</div>
								</div>
								<div
									className="elementor-element elementor-element-0eb9953 elementor-widget elementor-widget-heading"
									data-id="0eb9953"
									data-element_type="widget"
									data-widget_type="heading.default"></div>
								<div
									className=" elementor-element elementor-element-51531f3 elementor-widget elementor-widget-heading"
									data-id="51531f3"
									data-element_type="widget"
									data-widget_type="heading.default">
									<div className="elementor-widget-container  card-disc ">
										<h2 className="elementor-heading-title elementor-size-default">
											Lorem ipsum dolor sit amet.
										</h2>
									</div>
								</div>
								<div
									className="elementor-element elementor-element-eb948f6 elementor-shape-rounded elementor-grid-0 e-grid-align-center elementor-widget elementor-widget-social-icons"
									data-id="eb948f6"
									data-element_type="widget"
									data-widget_type="social-icons.default">
									<div className="elementor-widget-container">
										<button className="btn-card-primary">Mint</button>
									</div>
								</div>
							</div>
						</div>
						<div
							className="card elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-f10515a"
							data-id="f10515a"
							data-element_type="column">
							<div className="elementor-widget-wrap elementor-element-populated">
								<div
									className="elementor-element elementor-element-544481d elementor-widget elementor-widget-image"
									data-id="544481d"
									data-element_type="widget"
									data-widget_type="image.default">
									<div className="elementor-widget-container">
										<a href="https://www.linkedin.com/in/joeypescatore/">
											<img
												width={1080}
												height={1080}
												src="assets/collections/brutal-cracker.png"
												className="elementor-animation-shrink attachment-large size-large jetpack-lazy-image"
											/>
										</a>
									</div>
								</div>
								<div
									className="elementor-element elementor-element-c3e852c elementor-widget elementor-widget-heading"
									data-id="c3e852c"
									data-element_type="widget"
									data-widget_type="heading.default">
									<div className="elementor-widget-container">
										<h2 className="nft-card-heading elementor-heading-title elementor-size-default">
											<a href="https://www.linkedin.com/in/joeypescatore/">
												Brutal Cracker
											</a>
										</h2>
									</div>
								</div>
								<div
									className="elementor-element elementor-element-0eb9953 elementor-widget elementor-widget-heading"
									data-id="0eb9953"
									data-element_type="widget"
									data-widget_type="heading.default"></div>
								<div
									className=" elementor-element elementor-element-51531f3 elementor-widget elementor-widget-heading"
									data-id="51531f3"
									data-element_type="widget"
									data-widget_type="heading.default">
									<div className="elementor-widget-container  card-disc ">
										<h2 className="elementor-heading-title elementor-size-default">
											Lorem ipsum dolor sit amet.
										</h2>
									</div>
								</div>
								<div
									className="elementor-element elementor-element-eb948f6 elementor-shape-rounded elementor-grid-0 e-grid-align-center elementor-widget elementor-widget-social-icons"
									data-id="eb948f6"
									data-element_type="widget"
									data-widget_type="social-icons.default">
									<div className="elementor-widget-container">
										<button className="btn-card-primary">Mint</button>
									</div>
								</div>
							</div>
						</div>
						<div
							className="card elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-f10515a"
							data-id="f10515a"
							data-element_type="column">
							<div className="elementor-widget-wrap elementor-element-populated">
								<div
									className="elementor-element elementor-element-544481d elementor-widget elementor-widget-image"
									data-id="544481d"
									data-element_type="widget"
									data-widget_type="image.default">
									<div className="elementor-widget-container">
										<a href="https://www.linkedin.com/in/joeypescatore/">
											<img
												width={1080}
												height={1080}
												src="assets/collections/stud-coder.png"
												className="elementor-animation-shrink attachment-large size-large jetpack-lazy-image"
											/>
										</a>
									</div>
								</div>
								<div
									className="elementor-element elementor-element-c3e852c elementor-widget elementor-widget-heading"
									data-id="c3e852c"
									data-element_type="widget"
									data-widget_type="heading.default">
									<div className="elementor-widget-container">
										<h2 className="nft-card-heading elementor-heading-title elementor-size-default">
											<a href="https://www.linkedin.com/in/joeypescatore/">
												Stud Coder
											</a>
										</h2>
									</div>
								</div>
								<div
									className="elementor-element elementor-element-0eb9953 elementor-widget elementor-widget-heading"
									data-id="0eb9953"
									data-element_type="widget"
									data-widget_type="heading.default"></div>
								<div
									className=" elementor-element elementor-element-51531f3 elementor-widget elementor-widget-heading"
									data-id="51531f3"
									data-element_type="widget"
									data-widget_type="heading.default">
									<div className="elementor-widget-container  card-disc ">
										<h2 className="elementor-heading-title elementor-size-default">
											Lorem ipsum dolor sit amet.
										</h2>
									</div>
								</div>
								<div
									className="elementor-element elementor-element-eb948f6 elementor-shape-rounded elementor-grid-0 e-grid-align-center elementor-widget elementor-widget-social-icons"
									data-id="eb948f6"
									data-element_type="widget"
									data-widget_type="social-icons.default">
									<div className="elementor-widget-container">
										<button className="btn-card-primary">Mint</button>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="nft-row">
						<div
							className="card elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-f10515a"
							data-id="f10515a"
							data-element_type="column">
							<div className="elementor-widget-wrap elementor-element-populated">
								<div
									className="elementor-element elementor-element-544481d elementor-widget elementor-widget-image"
									data-id="544481d"
									data-element_type="widget"
									data-widget_type="image.default">
									<div className="elementor-widget-container">
										<a href="https://www.linkedin.com/in/joeypescatore/">
											<img
												width={1080}
												height={1080}
												src="assets/collections/hot-trek.png"
												className="elementor-animation-shrink attachment-large size-large jetpack-lazy-image"
											/>
										</a>
									</div>
								</div>
								<div
									className="elementor-element elementor-element-c3e852c elementor-widget elementor-widget-heading"
									data-id="c3e852c"
									data-element_type="widget"
									data-widget_type="heading.default">
									<div className="elementor-widget-container">
										<h2 className="nft-card-heading elementor-heading-title elementor-size-default">
											<a href="https://www.linkedin.com/in/joeypescatore/">
												Hot Trek
											</a>
										</h2>
									</div>
								</div>
								<div
									className="elementor-element elementor-element-0eb9953 elementor-widget elementor-widget-heading"
									data-id="0eb9953"
									data-element_type="widget"
									data-widget_type="heading.default"></div>
								<div
									className=" elementor-element elementor-element-51531f3 elementor-widget elementor-widget-heading"
									data-id="51531f3"
									data-element_type="widget"
									data-widget_type="heading.default">
									<div className="elementor-widget-container  card-disc ">
										<h2 className="elementor-heading-title elementor-size-default">
											Lorem ipsum dolor sit amet.
										</h2>
									</div>
								</div>
								<div
									className="elementor-element elementor-element-eb948f6 elementor-shape-rounded elementor-grid-0 e-grid-align-center elementor-widget elementor-widget-social-icons"
									data-id="eb948f6"
									data-element_type="widget"
									data-widget_type="social-icons.default">
									<div className="elementor-widget-container">
										<button className="btn-card-primary">Mint</button>
									</div>
								</div>
							</div>
						</div>
						<div
							className="card elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-f10515a"
							data-id="f10515a"
							data-element_type="column">
							<div className="elementor-widget-wrap elementor-element-populated">
								<div
									className="elementor-element elementor-element-544481d elementor-widget elementor-widget-image"
									data-id="544481d"
									data-element_type="widget"
									data-widget_type="image.default">
									<div className="elementor-widget-container">
										<a href="https://www.linkedin.com/in/joeypescatore/">
											<img
												width={1080}
												height={1080}
												src="assets/collections/chatty-gun.png"
												className="elementor-animation-shrink attachment-large size-large jetpack-lazy-image"
											/>
										</a>
									</div>
								</div>
								<div
									className="elementor-element elementor-element-c3e852c elementor-widget elementor-widget-heading"
									data-id="c3e852c"
									data-element_type="widget"
									data-widget_type="heading.default">
									<div className="elementor-widget-container">
										<h2 className="nft-card-heading elementor-heading-title elementor-size-default">
											<a href="https://www.linkedin.com/in/joeypescatore/">
												Chatty Gun
											</a>
										</h2>
									</div>
								</div>
								<div
									className="elementor-element elementor-element-0eb9953 elementor-widget elementor-widget-heading"
									data-id="0eb9953"
									data-element_type="widget"
									data-widget_type="heading.default"></div>
								<div
									className=" elementor-element elementor-element-51531f3 elementor-widget elementor-widget-heading"
									data-id="51531f3"
									data-element_type="widget"
									data-widget_type="heading.default">
									<div className="elementor-widget-container  card-disc ">
										<h2 className="elementor-heading-title elementor-size-default">
											Lorem ipsum dolor sit amet.
										</h2>
									</div>
								</div>
								<div
									className="elementor-element elementor-element-eb948f6 elementor-shape-rounded elementor-grid-0 e-grid-align-center elementor-widget elementor-widget-social-icons"
									data-id="eb948f6"
									data-element_type="widget"
									data-widget_type="social-icons.default">
									<div className="elementor-widget-container">
										<button className="btn-card-primary">Mint</button>
									</div>
								</div>
							</div>
						</div>
						<div
							className="card elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-f10515a"
							data-id="f10515a"
							data-element_type="column">
							<div className="elementor-widget-wrap elementor-element-populated">
								<div
									className="elementor-element elementor-element-544481d elementor-widget elementor-widget-image"
									data-id="544481d"
									data-element_type="widget"
									data-widget_type="image.default">
									<div className="elementor-widget-container">
										<a href="https://www.linkedin.com/in/joeypescatore/">
											<img
												width={1080}
												height={1080}
												src="assets/collections/dr-cocktail.png"
												className="elementor-animation-shrink attachment-large size-large jetpack-lazy-image"
											/>
										</a>
									</div>
								</div>
								<div
									className="elementor-element elementor-element-c3e852c elementor-widget elementor-widget-heading"
									data-id="c3e852c"
									data-element_type="widget"
									data-widget_type="heading.default">
									<div className="elementor-widget-container">
										<h2 className="nft-card-heading elementor-heading-title elementor-size-default">
											<a href="https://www.linkedin.com/in/joeypescatore/">
												Dr Cocktail
											</a>
										</h2>
									</div>
								</div>
								<div
									className="elementor-element elementor-element-0eb9953 elementor-widget elementor-widget-heading"
									data-id="0eb9953"
									data-element_type="widget"
									data-widget_type="heading.default"></div>
								<div
									className=" elementor-element elementor-element-51531f3 elementor-widget elementor-widget-heading"
									data-id="51531f3"
									data-element_type="widget"
									data-widget_type="heading.default">
									<div className="elementor-widget-container  card-disc ">
										<h2 className="elementor-heading-title elementor-size-default">
											Lorem ipsum dolor sit amet.
										</h2>
									</div>
								</div>
								<div
									className="elementor-element elementor-element-eb948f6 elementor-shape-rounded elementor-grid-0 e-grid-align-center elementor-widget elementor-widget-social-icons"
									data-id="eb948f6"
									data-element_type="widget"
									data-widget_type="social-icons.default">
									<div className="elementor-widget-container">
										<button className="btn-card-primary">Mint</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
		</>
	)
}
